import OpenModal from 'app/components/VideoModal/OpenModal';
import React from 'react';
import { getAccessServiceDescription } from '../../../../domain/AccessServiceTypes';
import CONTENTO_ACCESSIBILITIES from '../../../../domain/ContentoAccessibilities';
import { SVG_ICONS } from '../../../../ui-components/SvgIcon/SvgIcon';
import {
    StyledTopAreaVariantIcon,
    StyledTopAreaVariantLink,
    StyledTopAreaVariantNoWrap,
} from './TopAreaVariant.styles';

export const getIcon = (accessibility) => {
    if (accessibility === CONTENTO_ACCESSIBILITIES.SIGN_INTERPRETED) {
        return SVG_ICONS.SIGN_LANGUAGE;
    }

    if (accessibility === CONTENTO_ACCESSIBILITIES.AUDIO_DESCRIBED) {
        return SVG_ICONS.SIGHT;
    }

    return null;
};

const TopAreaVariant = ({ index, variant, onClick }) => {
    let prepend = index > 0 ? ' och ' : '';
    if (variant.accessibility !== CONTENTO_ACCESSIBILITIES.DEFAULT && index === 0) {
        prepend += 'som ';
    }

    return (
        <>
            {prepend}
            <StyledTopAreaVariantNoWrap>
                {variant.accessibility !== CONTENTO_ACCESSIBILITIES.DEFAULT && (
                    <StyledTopAreaVariantIcon icon={getIcon(variant.accessibility)} width={20} />
                )}
                <OpenModal videoId={variant.svtId} videoUrl={variant.urls.svtplay}>
                    {(handleOpenModal) => (
                        <StyledTopAreaVariantLink
                            onClick={() => {
                                handleOpenModal();
                                onClick(variant.accessibility);
                            }}
                            data-rt="top-area-a11y-link"
                        >
                            {getAccessServiceDescription(variant.accessibility)}
                        </StyledTopAreaVariantLink>
                    )}
                </OpenModal>
            </StyledTopAreaVariantNoWrap>
        </>
    );
};

export default TopAreaVariant;
